import { useState, useCallback } from 'react';
import ManagedVideo from '@/components/common/ManagedVideo';
import { getVideoUrl, getModuleHeroUrl } from '@/lib/media';

const DASHBOARD_VIDEO = getVideoUrl('tavian.mp4');
const DASHBOARD_FALLBACK_IMAGE = getModuleHeroUrl('lobby');

/**
 * Fullscreen video background + gradient overlay used by the dashboard and
 * its loading screens. Identical layout in every state so the loader →
 * loaded transition is seamless (no flash to a bare `bg-background`).
 *
 * Falls back to a still image if autoplay is blocked or the video errors.
 */
export function DashboardBackdrop() {
  const [videoFailed, setVideoFailed] = useState(false);
  const handleVideoError = useCallback(() => setVideoFailed(true), []);

  return (
    <>
      {!videoFailed ? (
        <ManagedVideo
          src={DASHBOARD_VIDEO}
          className="fixed inset-0 w-screen h-screen object-cover z-[1]"
          onAutoplayBlocked={handleVideoError}
          onError={handleVideoError}
        />
      ) : (
        <div
          className="fixed inset-0 z-[1]"
          style={{
            backgroundImage: `url(${DASHBOARD_FALLBACK_IMAGE})`,
            backgroundSize: 'cover',
            backgroundPosition: 'top',
            backgroundRepeat: 'no-repeat',
          }}
        />
      )}
      <div className="fixed inset-0 z-[2] pointer-events-none bg-gradient-to-b from-background/60 via-background/30 to-background/50" />
    </>
  );
}
